import { KarteTopic2 } from '@/gql/graphql';

export const karteTopicsLabelMap: Record<KarteTopic2, string> = {
  [KarteTopic2.FamilyBudgetImprovement]: '家計改善',
  [KarteTopic2.LifePlanning]: 'ライフプランニング',
  [KarteTopic2.EducationExpenses]: '教育資金',
  [KarteTopic2.Insurance]: '保険',
  [KarteTopic2.AssetManagement]: '資産運用',
  [KarteTopic2.Mortgage]: '住宅ローン',
  [KarteTopic2.Retirement]: '老後資金',
  [KarteTopic2.Inheritance]: '相続',
  [KarteTopic2.Debt]: '借金返済/債務整理',
  [KarteTopic2.CryptoCurrency]: '仮想通貨',
  [KarteTopic2.RealEstate]: '不動産',
  [KarteTopic2.Investment]: '投資/お金の勉強',
  [KarteTopic2.RealEstateInvestment]: '不動産投資',
  [KarteTopic2.BuyingAHouse]: '住宅購入',
  [KarteTopic2.JobChange]: '転職',
};
